<template>
  <div>
    <div class="bg-white dark-bg-custom rounded-lg">
      <ActitiveTabcomponent
        :tabs="mainTabs"
        :defaultTab="'lead'"
        @tab-changed="onTabChanged"
        ref="tabComponent"
      >
        <template #tab-buttons>
          <v-icon @click="cancelForm">mdi-close</v-icon>
        </template>
        <template #lead>
          <div class="form-content p-4 pb-0">
            <form class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <v-text-field
                v-model="leadName"
                dense
                required
                color="red"
                :label="leadLable.leadFormObj.lead + ' *'"
                hide-details
                outlined
              ></v-text-field>
              <v-autocomplete
                v-if="isComplaintsEnabled"
                v-model="productName"
                :items="products"
                item-text="productName"
                item-value="_id"
                dense
                label="Product Name"
                placeholder="Start typing to Search"
                :loading="productLoading"
                @update:search-input="debounceProduct"
                :search-input.sync="searchProduct"
                cache-items
                hide-no-data
                hide-details
                outlined
              ></v-autocomplete>

              <v-select
                v-if="leadLable.leadFormObj.productMaker"
                v-model="productMaker"
                dense
                :items="filteredProductMakers"
                item-text="maker.partnerName"
                item-value="maker._id"
                :label="leadLable.leadFormObj.productMaker"
                hide-details
                outlined
              ></v-select>

              <v-text-field
                v-if="leadLable.leadFormObj.modelNumber"
                v-model="modelNumber"
                dense
                :label="leadLable.leadFormObj.modelNumber"
                hide-details
                outlined
              ></v-text-field>

              <v-text-field
                v-if="isComplaintsEnabled"
                v-model="productBillNumber"
                dense
                label="Bill Number"
                hide-details
                outlined
              ></v-text-field>
              <v-text-field
                v-if="isComplaintsEnabled"
                type="number"
                v-model="productPrice"
                label="Product Price"
                hide-details
                outlined
                dense
              ></v-text-field>

              <div class="flex space-x-5" v-if="isComplaintsEnabled">
                <v-text-field
                  type="date"
                  v-model="productMakeDate"
                  label="Product Make Date"
                  hide-details
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  type="date"
                  v-model="productSoldOn"
                  label="Product Sale Date"
                  @input="calculateWarrantyEndDate"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </div>

              <v-select
                v-if="isComplaintsEnabled"
                :items="warrantyPeriods"
                item-text="text"
                item-value="value"
                v-model="defaultWarrantyPeriod"
                label="Warranty Period"
                @input="calculateWarrantyEndDate"
                hide-details
                outlined
                dense
              ></v-select>

              <v-text-field
                v-if="isComplaintsEnabled && !!productSoldOn"
                type="date"
                v-model="productWarrantyEndDate"
                label="Warranty End Date"
                disabled
                hide-details
                outlined
                dense
              ></v-text-field>
              <v-select
                v-if="isComplaintsEnabled && !!productSoldOn"
                v-model="warrantyStatus"
                label="Warranty Status:"
                :items="warrantyOptions"
                item-text="warranty"
                item-value="warranty"
                disabled
                hide-details
                outlined
                dense
              ></v-select>

              <v-select
                v-if="isComplaintsEnabled"
                v-model="haveExtendedWarranty"
                label="Extended Warranty"
                :items="[
                  { text: 'Yes', value: true },
                  { text: 'No', value: false }
                ]"
                item-value="value"
                item-text="text"
                hide-details
                outlined
                dense
              ></v-select>

              <v-text-field
                v-if="haveExtendedWarranty"
                type="number"
                label="Extended Warranty Period"
                v-model="extendedWarrantyPeriod"
                hide-details
                outlined
                dense
              ></v-text-field>

              <!-- AMC Plan Active -->

              <v-select
                v-if="isComplaintsEnabled"
                v-model="haveAmcPlan"
                label="AMC Plan Active"
                :items="[
                  { text: 'AMC Active', value: true },
                  { text: 'AMC Inactive', value: false },
                  { text: 'N/A', value: null }
                ]"
                hide-details
                outlined
                dense
              ></v-select>

              <v-text-field
                v-if="haveAmcPlan !== null"
                type="date"
                v-model="productAmcEndDate"
                label="AMC End Date"
                required
                :rules="rules.amcEndDate"
                hide-details
                outlined
                dense
              ></v-text-field>

              <!-- Lead Description -->

              <v-text-field
                v-if="isDefaultEnabled"
                v-model="sourceOfLead"
                label="Source of lead"
                hide-details
                outlined
                dense
              ></v-text-field>

              <v-combobox
                v-if="isDefaultEnabled"
                v-model="leadTags"
                :items="tags"
                hide-selected
                hint="Press Enter to add new tag"
                label="Add Lead Tags"
                persistent-hint
                multiple
                small-chips
                hide-details
                outlined
                dense
              >
                <template v-slot:selection="{ item }">
                  <v-chip @click="removeChip(item, leadTags)">
                    {{ item }}
                    <v-icon small class="ml-2">mdi-close-circle</v-icon>
                  </v-chip>
                </template>
              </v-combobox>

              <!-- Company Name -->
              <v-autocomplete
                v-model="selectedCompanyId"
                :label="leadLable.leadFormObj.companyName"
                :search-input.sync="searchCompany"
                :items="companies"
                item-text="name"
                item-value="_id"
                append-icon="mdi-plus"
                @click:append="showAddCompany = true"
                @update:search-input="handleCompany"
                hide-details
                outlined
                dense
              >
              </v-autocomplete>
              <!-- Company Branch -->
              <v-autocomplete
                class="md:col-span-2"
                :label="leadLable.leadFormObj.companyBranch"
                v-model="selectedBranchId"
                :items="selectedCompanyBranches"
                :disabled="!selectedCompanyId"
                item-value="_id"
                :search-input.sync="searchBranch"
                :item-text="
                  (item) =>
                    `${item.alias ? '[ ALIAS - ' + item.alias + ' ] - ' : ''}${
                      item?.address?.addressLine1 || ''
                    } ${item?.address?.addressLine2 || ''} ${item?.address?.city || ''}, ${
                      item?.address?.state || ''
                    }, ${item?.address?.country || ''}, ${item?.address?.pinCode || ''}`
                "
                :append-icon="selectedCompanyId ? 'mdi-plus' : ''"
                @click:append="showAddBranch = true"
                @update:search-input="handleBranchSearch"
                hide-details
                outlined
                dense
              >
              </v-autocomplete>

              <!-- Lead Description -->
              <div class="md:col-span-2" v-if="!isComplaintsEnabled">
                <v-textarea
                  @input="validateLeadDescription"
                  auto-grow
                  :label="leadLable.leadFormObj.description"
                  v-model="leadDescription"
                  hide-details
                  outlined
                  dense
                ></v-textarea>

                <div class="flex justify-end">
                  <p class="text-sm text-gray-500 mb-0">{{ remainingChar }} character remaining</p>
                </div>
              </div>

              <div class="flex justify-between items-center">
                <h2 class="text-2xl mt-16 mb-8" v-if="selectedBranchId !== null">
                  Contact Details
                </h2>
                <a
                  v-if="selectedCompanyId !== '' && selectedBranchId !== null"
                  class="dark-hover-text"
                  @click="openAddContactDialog"
                >
                  + Add Contact
                </a>
              </div>

              <!-- Auto Populate Contact -->
              <div v-for="contact in editableContacts" class="space-y-4" :key="contact._id">
                <v-text-field
                  v-model="contact.fullName"
                  dense
                  :label="contactLabels.contactLabels"
                  hide-details
                  outlined
                >
                </v-text-field>

                <v-text-field
                  v-model="contact.designation"
                  dense
                  :label="contactLabels.contactDesignation"
                  hide-details
                  outlined
                >
                </v-text-field>

                <v-text-field
                  v-model="contact.phoneNumber"
                  dense
                  :label="contactLabels.contactNumber"
                  hide-details
                  outlined
                >
                </v-text-field>

                <v-text-field
                  v-model="contact.email"
                  dense
                  :label="contactLabels.contactEmail"
                  hide-details
                  outlined
                >
                </v-text-field>

                <v-text-field
                  v-model="contact.decisionMaker"
                  dense
                  :label="contactLabels.decision"
                  hide-details
                  outlined
                >
                </v-text-field>

                <div class="flex items-center w-5/6 mt-4 space-x-5">
                  <label for="selectContact" class="block font-medium w-32 text-[#464A53]"
                    >Select as primary:</label
                  >
                  <div class="flex items-center">
                    <input
                      type="checkbox"
                      :id="'contactCheckbox_' + contact._id"
                      :value="contact._id"
                      :checked="selectedContactId === contact._id"
                      @change="updateSelectedContact(contact._id)"
                      class="form-checkbox h-5 w-5 text-[#2A83FF]"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </template>
        <template #bulk>
          <GenericBulkUpload
            :title="'Add Lead'"
            :entityName="'Lead'"
            :requiredColumns="requiredColumns"
            :uploadEndpoint="uploadEndpoint"
            @save-button-visibility="handleSaveButtonVisibility"
            :successKey="'success'"
            :failedKey="'failed'"
            :invalidItemsKey="'invalidItems'"
            :method="'post'"
            :enableSave="false"
            :controlParentSaveButton="true"
            :sampleData="sampleData"
            :additionalPayload="additionalPayload"
          />
        </template>
      </ActitiveTabcomponent>

      <div class="flex justify-end p-4 border-t border-gray-200">
        <v-btn @click="cancelForm" text class="normal-case"> Cancel </v-btn>
        <v-btn
          v-if="showSaveButton"
          type="submit"
          :color="$vuetify.theme.currentTheme.primary"
          class="normal-case white--text"
          @click="addLead"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="showAddCompany" width="auto">
      <CompanyAddress
        :isOpen="showAddCompany"
        @cancel="showAddCompany = false"
        @save="addCompany"
        title="Add Company"
        :companies="companies"
      />
    </v-dialog>
    <v-dialog v-model="showAddBranch" width="auto">
      <CompanyAddress
        :company="selectedCompanyName"
        @cancel="showAddBranch = false"
        :isOpen="showAddBranch"
        @save="addBranch"
        title="Add Branch"
      />
    </v-dialog>
    <v-dialog v-model="showContactDialog" max-width="600">
      <AddContact
        :selectedBranchId="selectedBranchId"
        @close="showContactDialog = false"
        @contact-added="handleContactAdded"
      />
    </v-dialog>
  </div>
</template>

<script>
import CompanyAddress from '@/components/Workforce/CompanyAddress.vue'
import AddContact from '../CompanyManagement/AddContactForm.vue'
import {
  leadCreationSuccess,
  leadCreationError,
  companyCreationSuccess,
  companyCreationError,
  descriptionLimit
} from '@/utils/toastMessages'
import { sortDropdownOptions } from '@/utils/common'
import { leadLabels, contactLabels } from '@/utils/workforce/formLabels'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import { debounce } from '@/utils/common'
import GenericBulkUpload from '../CollectionManagement/GenericBulkUpload.vue'
import { axiosUrl } from '@/utils/workforceApi'

export default {
  layout: 'Workforce/default',
  name: 'AddLeadDuplicate',
  components: {
    AddContact,
    ActitiveTabcomponent,
    GenericBulkUpload,
    CompanyAddress
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      orgLang: this.$store.state.orgLanguage,
      orgCode: this.$storage.getUniversal('organization_code'),
      leadLabels: leadLabels,
      contactLabels: contactLabels,
      isLoading: true,
      productLoading: false,
      showModal: false,
      leads: [],
      contacts: [],
      products: [],
      leadTags: [],
      sourceOfLead: '',
      tags: [],
      warrantyOptions: ['IN_WARRANTY', 'OUT_OF_WARRANTY'],
      tasks: {},
      selectedLeadId: null,
      selectedBranchId: null,
      isModalOpen: false,
      selectedCompanyId: '',
      selectedContactId: null,
      showForm: false,
      checkBranch: false,
      leadTitle: '',
      company: '',
      ContactName: '',
      productName: null,
      nextContactIndex: 0,
      allContactsAdded: false,
      leadNameFilter: '',
      leadName: '',
      formSubmitted: false,
      searchCompany: null,
      productMaker: null,
      modelNumber: '',
      leadDescription: '',
      ContactFirstName: '',
      ContactDesignation: '',
      ContactNumber: '',
      ContactEmail: '',
      decisionMaker: '',
      searchProduct: null,
      productBillNumber: '',
      showContactDialog: false,
      showAddCompany: false,
      showAddBranch: false,
      warrantyPeriods: [
        { text: '6 Months', value: 0.5 },
        { text: '1 Years', value: 1 },
        { text: '2 Years', value: 2 },
        { text: '3 Years', value: 3 },
        { text: '5 Years', value: 5 }
      ],
      productPrice: null,
      haveExtendedWarranty: false,
      extendedWarrantyPeriod: null,
      defaultWarrantyPeriod: 1,
      haveAmcPlan: null,
      warrantyStatus: undefined,
      productSoldOn: null,
      productWarrantyEndDate: null,
      productMakeDate: null,
      productAmcEndDate: null,
      isEditing: false,
      localEditItems: {}, // Create a local copy of editItems
      editableContacts: [], // Store editable contact data
      activeTab: 'lead', // Track the active tab
      showSaveButton: true, // Control save button visibility
      rules: {
        amcEndDate: [
          (val) => {
            if (this.haveAmcPlan !== null) {
              return (val || '').length > 0 || `AMC end date is required`
            }
            return true
          }
        ]
      }
    }
  },
  props: {
    tabSwitch: Function,
    fetchCompanies: Function,
    companies: Array,
    editItems: Object,
    useCaseLeadConfig: Object
  },
  watch: {
    editItems: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.localEditItems = { ...newVal }
          this.$nextTick(() => {
            this.populateEditData()
          })
        }
      },
      immediate: true,
      deep: true
    },
    selectedCompanyContacts: {
      handler(newVal) {
        // Update editable contacts when selected company contacts change
        this.updateEditableContacts(newVal)
      },
      immediate: true
    }
  },
  async mounted() {
    this.populateLeadName()
    if (this.localEditItems && Object.keys(this.localEditItems).length > 0) {
      // Use nextTick to ensure DOM is updated before populating data
      this.$nextTick(() => {
        this.populateEditData()
      })

      if (this.localEditItems?.company?.name) {
        this.$emit('search', this.localEditItems.company.name)
      }

      if (this.localEditItems?.productName?.productName) {
        this.searchProduct = this.localEditItems.productName.productName
        await this.fetchProducts()
      }
    }
  },
  computed: {
    mainTabs() {
      const tabs = [
        {
          label: this.isEditing ? `Edit` : `Add `,
          key: 'lead',
          icon: this.isEditing ? 'mdi-pencil' : 'mdi-plus',
          component: 'AddLender'
        },
        {
          label: this.isEditing ? 'Bulk update' : 'Bulk create',
          key: 'bulk',
          icon: 'mdi-upload',
          component: 'GenericBulkUpload'
        }
      ]
      return tabs
    },
    selectedCompanyName() {
      if (this.selectedCompanyId) {
        const selectedCompany = this.companies.find(
          (company) => company._id === this.selectedCompanyId
        )
        return selectedCompany ? selectedCompany.name : ''
      }
      return ''
    },
    selectedCompanyContacts() {
      if (this.selectedBranchId !== null) {
        const selectedBranch = this.selectedCompanyBranches.find(
          (branch) => branch._id === this.selectedBranchId
        )
        return selectedBranch ? selectedBranch.contacts : []
      }
      return []
    },
    selectedCompanyBranches() {
      const selectedCompany = this.companies.find(
        (company) => company._id === this.selectedCompanyId
      )

      return selectedCompany
        ? sortDropdownOptions(selectedCompany.companyBranches, 'address.addressLine1')
        : []
    },
    filteredProductMakers() {
      if (!this.productName) return []
      const selectedProduct = this.products.find((product) => product._id === this.productName)
      return selectedProduct ? sortDropdownOptions(selectedProduct.productMaker, 'partnerName') : []
    },
    remainingChar() {
      const character = this.leadDescription
        .trim()
        .split('')
        .filter((character) => character !== '')
      return 300 - character.length
    },
    leadLable() {
      return {
        leadTitle: this.$props.useCaseLeadConfig?.addLeadForm.lead,
        leadFormObj: this.$props.useCaseLeadConfig?.addLeadForm,
        description: this.$props.useCaseLeadConfig?.addLeadForm.description
      }
    },
    isComplaintsEnabled() {
      if (this.$route.params.usecase === 'inventory') return true
      return false
    },
    isDefaultEnabled() {
      return this.$route.params.usecase === 'default'
    }
  },
  methods: {
    resetForm() {
      // Reset all form fields to their initial state
      this.selectedBranchId = null
      this.selectedCompanyId = ''
      this.selectedContactId = null
      this.productName = null
      this.productMaker = null
      this.modelNumber = ''
      this.leadDescription = ''
      this.productBillNumber = ''
      this.productPrice = null
      this.haveExtendedWarranty = false
      this.extendedWarrantyPeriod = null
      this.defaultWarrantyPeriod = 1
      this.haveAmcPlan = null
      this.warrantyStatus = undefined
      this.productSoldOn = null
      this.productWarrantyEndDate = null
      this.productMakeDate = null
      this.productAmcEndDate = null
      this.leadName = ''
      this.sourceOfLead = ''
      this.leadTags = []
      this.isEditing = false
      this.localEditItems = {}
      this.editableContacts = [] // Reset editable contacts
    },

    updateEditableContacts(contacts) {
      // Convert contact objects to editable format
      this.editableContacts = contacts.map((contact) => ({
        _id: contact._id,
        fullName: `${contact.firstName || ''} ${contact.lastName || ''}`.trim(),
        firstName: contact.firstName || '',
        lastName: contact.lastName || '',
        designation: contact.designation || '',
        phoneNumber: contact.phoneNumber || '',
        email: contact.email || '',
        decisionMaker: contact.isDecisionMaker ? 'Yes' : 'No',
        isDecisionMaker: contact.isDecisionMaker || false
      }))
    },

    populateEditData() {
      if (!this.localEditItems || Object.keys(this.localEditItems).length === 0) {
        return
      }

      const formatDate = (date) => (date ? this.$dayjs(date).format('YYYY-MM-DD') : null)

      // Set all the form fields based on the edit data
      this.selectedBranchId = this.localEditItems?.selectedBranch || null
      this.selectedCompanyId = this.localEditItems?.company?._id || ''
      this.selectedContactId = this.localEditItems?.selectedContact || null
      this.productName = this.localEditItems?.productName?._id || null
      this.productMaker = this.localEditItems?.productManufacturer?._id || null
      this.modelNumber = this.localEditItems?.productModelNumber || ''
      this.leadDescription = this.localEditItems?.leadDescription || ''
      this.productBillNumber = this.localEditItems?.productBillNumber || ''
      this.productPrice = this.localEditItems?.productPrice || null
      this.haveExtendedWarranty = this.localEditItems?.productHaveExtendedWarranty || false
      this.extendedWarrantyPeriod = this.localEditItems?.productExtendedWarrantyPeriod || null
      this.defaultWarrantyPeriod = this.localEditItems?.productDefaultWarrantyPeriod || 1
      this.haveAmcPlan = this.localEditItems?.productHaveAmcPlan || null
      this.warrantyStatus = this.localEditItems?.productWarrantyStatus || undefined
      this.productSoldOn = formatDate(this.localEditItems?.productSoldOn) || null
      this.productWarrantyEndDate = formatDate(this.localEditItems?.productWarrantyEndDate) || null
      this.productMakeDate = formatDate(this.localEditItems?.productMakeDate) || null
      this.productAmcEndDate = formatDate(this.localEditItems?.productAmcDate) || null
      this.leadName = this.localEditItems?.leadTitle || ''
      this.sourceOfLead = this.localEditItems?.sourceOfLead || ''
      this.leadTags = this.localEditItems?.tags || []

      // Set the isEditing flag
      this.isEditing = !!this.localEditItems?._id

      // Trigger company and product searches if needed
      if (this.localEditItems?.company?.name) {
        this.$emit('search', this.localEditItems.company.name)
      }

      if (this.localEditItems?.productName?.productName) {
        this.searchProduct = this.localEditItems.productName.productName
        this.fetchProducts()
      }
    },
    async addLead() {
      this.formSubmitted = true
      if (!this.leadName.trim()) {
        return
      }
      try {
        const currentUsecase = this.$route.params.usecase.toLowerCase()
        const leadNames = this.leadName.split(',').map((name) => name.trim())

        const leadCreationPromises = leadNames.map(async (leadTitle) => {
          const data = {
            leadTitle: leadTitle,
            leadDescription: this.leadDescription,
            useCase: currentUsecase
          }
          if (this.selectedCompanyId) {
            data.company = this.selectedCompanyId
          }
          if (this.selectedBranchId) {
            data.selectedBranch = this.selectedBranchId
          }
          if (this.selectedContactId) {
            data.selectedContact = this.selectedContactId
          }
          if (this.isComplaintsEnabled) {
            data.productManufacturer = this.productMaker || undefined
            data.productModelNumber = this.modelNumber || ''
            data.productMakeDate = this.productMakeDate || null
            data.productSoldOn = this.productSoldOn || null
            data.productPrice = this.productPrice || null
            data.productWarrantyEndDate = this.productWarrantyEndDate || null
            data.productHaveExtendedWarranty = this.haveExtendedWarranty
            data.productExtendedWarrantyPeriod = this.extendedWarrantyPeriod || null
            data.productDefaultWarrantyPeriod = this.defaultWarrantyPeriod || null
            data.productHaveAmcPlan = this.haveAmcPlan
            data.productAmcEndDate = this.productAmcEndDate
            data.productWarrantyStatus = this.warrantyStatus
            data.productBillNumber = this.productBillNumber
            data.productName = this.productName || undefined
          }
          if (this.sourceOfLead || this.leadTags) {
            data.sourceOfLead = this.sourceOfLead
            data.tags = this.leadTags
          }
          let response
          if (this.isEditing) {
            response = await this.$axios.put(`/lead/${this.localEditItems?._id}`, data)
          } else {
            response = await this.$axios.post(`/lead`, data)
          }
          return response
        })
        await Promise.all(leadCreationPromises)
        this.leadName = ''
        this.leadDescription = ''
        this.productMaker = ''
        this.modelNumber = ''
        this.selectedCompanyId = ''
        this.selectedBranchId = null
        this.selectedContactId = null
        this.$toast.success(leadCreationSuccess(this.leadLable.leadTitle))
        this.showForm = false

        // Reset the form
        this.resetForm()

        // Emit event to notify parent component to refresh leads data
        this.$emit('lead-created')

        // Close the dialog
        this.$emit('close')

        // Navigate back to leads tab, but only if not already there
        const currentRoute = this.$route.query.activeTab
        if (currentRoute !== 'leads') {
          this.$router
            .replace({
              query: { ...this.$route.query, activeTab: 'leads' }
            })
            .catch((err) => {
              if (err.name !== 'NavigationDuplicated') {
                throw err
              }
            })
        }
      } catch (error) {
        this.$toast.error(leadCreationError(this.leadLable.leadTitle))
        console.error('Error creating new lead:', error)
      }
    },
    decisionMakerDisplay() {
      if (this.contact.isDecisionMaker === true) {
        return 'Yes'
      } else if (this.contact.isDecisionMaker === false) {
        return 'No'
      } else {
        return ''
      }
    },
    handleSaveButtonVisibility(visible) {
      // This is called by GenericBulkUpload when its internal tabs change
      const activeTab = this.$refs.tabComponent?.activeTab || 'lead'
      if (activeTab === 'bulk') {
        this.showSaveButton = visible
      } else {
        this.showSaveButton = true
      }
    },
    onTabChanged(tabKey) {
      if (tabKey === 'lead') {
        this.showSaveButton = true
      }
    },
    async addCompany(data) {
      const company = {
        name: data.companyName,
        companyDetails: data.companyDetails,
        companyBranches: [
          {
            alias: data.companyName,
            address: {
              addressLine1: data.addLine1,
              addressLine2: data.addLine2,
              city: data.city,
              state: data.state,
              country: data.country,
              pinCode: data.pinCode,
              coordinates: {
                latitude: data.latitude,
                longitude: data.longitude
              }
            }
          }
        ]
      }

      try {
        const response = await this.$axios.post('/company', company)

        this.companies.push(response.data.company)
        this.showAddCompany = false
        this.$toast.success(companyCreationSuccess)
      } catch (error) {
        console.error(companyCreationError, error)
        this.$toast.error(companyCreationError)
      }
    },
    validateLeadDescription() {
      const characterCount = this.leadDescription.trim().length
      if (characterCount > 300) {
        this.$toast.error(descriptionLimit)
        this.leadDescription = this.leadDescription.substring(0, 300)
      }
    },
    openAddContactDialog() {
      this.showContactDialog = true
    },
    removeChip(item, options) {
      const index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
      if (this.leadTags.length > 0) {
        this.tags = this.leadTags
      }
    },
    handleContactAdded(updatedCompany) {
      const existingCompanyIndex = this.companies.findIndex(
        (company) => company._id === updatedCompany._id
      )
      if (existingCompanyIndex !== -1) {
        this.$set(this.companies, existingCompanyIndex, updatedCompany)
      }
      this.showContactDialog = false
      // Refresh company data to ensure the contact list is updated
      if (this.fetchCompanies) {
        this.fetchCompanies()
      }
    },
    async addBranch(data) {
      this.checkBranch = true
      const companyId = this.selectedCompanyId
      const company = {
        branch: {
          alias: data.alias,
          address: {
            addressLine1: data.addLine1,
            addressLine2: data.addLine2,
            city: data.city,
            state: data.state,
            country: data.country,
            pinCode: data.pinCode,
            coordinates: {
              latitude: data.latitude,
              longitude: data.longitude
            }
          }
        }
      }

      try {
        const response = await this.$axios.post(`/addBranch/${companyId}`, company)
        const newBranch = response.data.company.companyBranches
        this.selectedCompanyBranches.push(newBranch[newBranch.length - 1])
        this.checkBranch = false
        this.showAddBranch = false
        const successMessage = response?.data?.message || 'Company Branch Added Successfully !!!'
        this.$toast.success(successMessage)
      } catch (error) {
        console.error('Error in company addition', error)
        const errorMessage = error.response.data.message || 'Error in company branch addition !!!'
        this.$toast.error(errorMessage)
      }
    },
    cancelForm() {
      // Reset the form
      this.resetForm()

      // Close the dialog
      this.$emit('close')

      // Navigate back to leads tab, but only if not already there
      const currentRoute = this.$route.query.activeTab
      if (currentRoute !== 'leads') {
        this.$router
          .replace({
            query: { ...this.$route.query, activeTab: 'leads' }
          })
          .catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
      }
    },
    updateSelectedContact(contactId) {
      this.selectedContactId = contactId
    },
    calculateWarrantyEndDate() {
      if (this.productSoldOn) {
        const saleDate = this.$dayjs(this.productSoldOn)
        const years = Math.floor(this.defaultWarrantyPeriod)
        const months = Math.round((this.defaultWarrantyPeriod % 1) * 12)

        let warrantyEnd = saleDate.add(years, 'year').add(months, 'month')

        this.productWarrantyEndDate = warrantyEnd.format('YYYY-MM-DD')

        const currentDate = this.$dayjs()
        if (warrantyEnd.isAfter(currentDate)) {
          this.warrantyStatus = 'IN_WARRANTY'
        } else {
          this.warrantyStatus = 'OUT_OF_WARRANTY'
        }
      }
    },
    debounceProduct: debounce(function (text) {
      if (!text && this.localEditItems && Object.keys(this.localEditItems).length > 0) {
        this.products = []
        return
      }
      this.fetchProducts()
    }, 1000),
    async fetchProducts() {
      try {
        this.productLoading = true
        const params = {}
        if (this.searchProduct) {
          params.search = this.searchProduct
        }
        const response = await this.$axios.get(axiosUrl.products.getProducts, {
          params
        })
        const allProducts = response.data?.products

        this.products = sortDropdownOptions(allProducts, 'productName')
      } catch (error) {
        console.error('An error occurred:', error)
      } finally {
        this.productLoading = false
      }
    },
    populateLeadName() {
      let leadTitle = this.localEditItems?.leadTitle

      if (this.isComplaintsEnabled && !leadTitle) {
        this.leadName = this.generateLeadTitle()
      } else if (leadTitle) {
        this.leadName = leadTitle
      }
    },
    generateLeadTitle() {
      const prefix = 'SR_NO_'
      const dateTime = this.$dayjs().format('DD/MM/YY/hhmmss')
      return `${prefix}${dateTime}`
    },
    handleCompany: debounce(function () {
      if (this.selectedCompanyId) return
      this.$emit('search', this.searchCompany)
    }, 1000)
  }
}
</script>
<style>
.cancel {
  border: 1px solid #2a83ff;
  background: white;
}
.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea {
  margin: 0px !important;
}
.form-title {
  font-size: 1.25rem;
  font-weight: 600;
  padding: 0px;
  color: #21427d;
  margin: 0;
}
.form-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
